import Swiper from "swiper";
import {
  Pagination,
  EffectCreative,
  Keyboard,
  Mousewheel,
  Navigation,
  Thumbs,
  EffectFade,
  Autoplay,
  EffectCoverflow,
  Grid,
  FreeMode,
} from "swiper/modules";

/**
 * @param swiperInit
 */
export default function swiperInit() {
  $(".col-3-products .swiper").each(function () {
    new Swiper(this, {
      modules: [Pagination, Autoplay, Navigation],
      slidesPerView: 1,
      spaceBetween: 40,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      loop: true,
      pagination: {
        el: $(this).closest(".swiper-cols-1").find(".swiper-pagination")[0],
        clickable: true,
      },
      navigation: {
        nextEl: $(this).closest(".col-3-products").find(".btn-next")[0],
        prevEl: $(this).closest(".col-3-products").find(".btn-prev")[0],
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1290: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
      on: {
        init: function () {
          this.autoplay.start();
        },
      },
    });
  });
  const swiper4 = () =>
    $(".col-4-products .swiper").each(function () {
      new Swiper(this, {
        modules: [Pagination, Autoplay, Navigation],
        slidesPerView: 2,
        spaceBetween: 40,
        autoplay: {
          delay: 4000,
        },
        loop: false,
        pagination: {
          el: $(this).closest(".swiper-cols-1").find(".swiper-pagination")[0],
          clickable: true,
        },
        navigation: {
          nextEl: $(this).closest(".col-4-products").find(".btn-next")[0],
          prevEl: $(this).closest(".col-4-products").find(".btn-prev")[0],
        },
        breakpoints: {
          1200: {
            slidesPerView: 4,
          },
        },
      });
    });
  swiper4();
  window.swiper4 = swiper4;
  $(".col-6-posts .swiper").each(function () {
    new Swiper(this, {
      modules: [Pagination, Autoplay, Navigation],
      slidesPerView: 2,
      spaceBetween: 15,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      loopedSlides: 6,
      autoplay: {
        delay: 4000,
      },
      loop: true,

      pagination: {
        el: $(this).closest(".col-6-posts").find(".swiper-pagination")[0],
        clickable: true,
        type: "progressbar",
      },
      navigation: {
        nextEl: $(this).closest(".col-4-posts").find(".btn-next")[0],
        prevEl: $(this).closest(".col-4-posts").find(".btn-prev")[0],
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    });
  });
  $(".col-1-products .swiper").each(function () {
    new Swiper(this, {
      modules: [Pagination, Autoplay, Navigation, EffectFade],
      slidesPerView: 1,
      spaceBetween: 2,
      autoplay: {
        delay: 10000,
      },
      speed: 2000,
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: $(this).closest(".col-1-products").find(".swiper-pagination")[0],
        renderBullet: function (index, className) {
          // Get total number of slides
          const totalSlides = this.slides.length;
          // Only add dash separator if not last bullet
          const separator = index < totalSlides - 1 ? " - " : "";
          return (
            '<span class="' +
            className +
            '" style="opacity: 0.7; transition: opacity 0.3s">' +
            (index < 9 ? "0" : "") +
            (index + 1) +
            "</span>" +
            separator
          );
        },
        clickable: true,
        type: "bullets",
      },
      navigation: {
        nextEl: $(this).closest(".col-1-products").find(".btn-next")[0],
        prevEl: $(this).closest(".col-1-products").find(".btn-prev")[0],
      },
    });
  });
  $(".col-1-posts .swiper").each(function () {
    new Swiper(this, {
      modules: [Autoplay, Navigation, EffectFade],
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 4000,
      },
      speed: 2000,
      loop: true,
      effect: "slide",
      navigation: {
        nextEl: $(this).closest(".col-1-posts").find(".btn-next")[0],
        prevEl: $(this).closest(".col-1-posts").find(".btn-prev")[0],
      },
    });
  });
  $(".home-cols-9 .swiper").each(function (index) {
    const nameVariable = `swiper_brand_${index}`;
    window[nameVariable] = new Swiper(this, {
      modules: [Autoplay],
      slidesPerView: 3,
      spaceBetween: 32,
      speed: 3000,
      loop: true,
      freeMode: true,
      observer: true,
      observeParents: true,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 9,
          spaceBetween: 24,
        },
      },
    });
  });
}
